module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-header\">\n	<div class=\"gl-header__system-bar\">\n		<div class=\"split\">\n			<div class=\"split__left\">\n				<div>\n					Версия <span name=\"version\" class=\"title\"></span>\n				</div>\n			</div>\n			<div class=\"split__right\">\n			</div>\n		</div>\n\n		<div name=\"serverTime\" style=\"position: absolute; left: 50%; top: 1px; width: 200px; margin-left: -100px; text-align: center\">\n		</div>\n	</div>\n	<div class=\"gl-header__app-bar\">\n		<div class=\"split\">\n			<div class=\"split__left\">\n				<div>\n					<div class=\"gl-header__icon icon-24 icon-home\" on-click=\"onHomeClick\"></div>\n				</div>\n			</div>\n			<div class=\"split__right\">\n				<div>\n					<div class=\"gl-header__icon icon-24 icon-exit_to_app\" on-click=\"onExitClick\"></div>\n				</div>\n				<div class=\"table\">\n					<div>\n						<div name=\"userName\" class=\"cell__center cell__middle\">\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}